import { Box, Center, Container, Flex, HStack, Heading, Spacer, Stack, Text, VStack } from '@chakra-ui/react';
import { PageFooter } from 'components/layout/footer';
import { EmployeeTopNav, FormHeader, PageHeader } from 'components/layout/header';
import { StandardCard } from 'components/shared/card';
import { LanguageSelector } from 'components/shared/languageSelector';
import { useLangContext } from 'configs/languageContext';
import { form } from 'data/translations';
import { PropsWithChildren } from 'react';

interface pageProps { sidebar: Boolean }
const defaultProps: PropsWithChildren<pageProps> = { sidebar: false }

// When `sidebar` is true we're inside the employee area; render the new top
// nav instead of the old left rail. Public pages keep the standard header.
export const TemplatePage = (props: PropsWithChildren<pageProps>) => {
    if (props.sidebar) {
        return (
            <Flex direction="column" minH="100vh" bg="#F8FAFC">
                <EmployeeTopNav />
                <Box flex="1" w="100%" maxW="1280px" mx="auto" px={{ base: 3, md: 6 }} py={{ base: 4, md: 6 }}>
                    {props.children}
                </Box>
                <PageFooter />
            </Flex>
        );
    }

    return (
        <Flex direction="column" minH="100vh" bg="white">
            <PageHeader />
            <Stack maxW={{ 'base': '750px', 'lg': '970px', 'xl': '1170px' }} w='100%'
                mx='auto' transition={'all 0.5s ease'}
                spacing={8} p={4} align={'baseline'} flex="1">
                {props.children}
            </Stack>
            <Spacer />
            <PageFooter />
        </Flex>
    );
}
TemplatePage.defaultProps = defaultProps;


interface loginProps { heading?: String, footer?: String }
export const TemplateLogin = (props: PropsWithChildren<loginProps>) => (
    <Center minH="100vh" bg='#F8FAFC' >
        <VStack w='100%' maxW='600px' px={2}>
            <HStack justifyContent={'space-between'} w='100%' mb={2}>
                {props.heading &&
                    <Heading
                        fontSize={{ base: '2xl', sm: '3xl', md: '4xl', lg: '5xl' }}
                        transition={'all 0.5s ease'}
                        textTransform={'capitalize'} wordBreak={'break-word'}
                        color="#0F172A"
                    >
                        {props.heading}
                    </Heading>
                }
                <LanguageSelector staff />
            </HStack>

            <StandardCard>{props.children}</StandardCard>

            {props.footer &&
                <Text fontSize={18} fontWeight={'semibold'}>{props.footer}</Text>
            }
        </VStack>
    </Center>
)


export const TemplateForm = (props: PropsWithChildren) => {
    const { lang } = useLangContext();
    return (
        <Box minH="100vh" w='100%' bg='#F8FAFC' px={{ base: 3, md: 4 }} py={{ base: 4, md: 6 }}>
            <FormHeader />

            <Container
                bg='white'
                maxW='800px'
                borderRadius='2xl'
                borderWidth='1px'
                borderColor='#E2E8F0'
                boxShadow='0 12px 36px rgba(15,23,42,0.06)'
                px={{ base: 5, md: 8 }}
                py={{ base: 6, md: 8 }}
            >
                <Heading
                    as='h1'
                    w='100%'
                    fontSize={{ base: '2xl', md: '3xl' }}
                    fontWeight='800'
                    letterSpacing='-0.025em'
                    color='#0F172A'
                    textAlign='center'
                    mb={6}
                    textTransform='capitalize'
                >
                    {form.head[lang]}
                </Heading>
                {props.children}
            </Container>
        </Box>
    )
}
